<template>
  <v-app>
    <v-toolbar app>
      <img class="maxheight" src="./assets/HSWLogo.png">
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn class="v-btn--flat" href="tel:888-440-0599">888-440-0599</v-btn>
        <!--<v-btn @click.stop="dialog = true" v-if="!dialog" flat>ORDER NOW</v-btn>-->
        <v-btn @click.stop="terms = true" flat>SAMPLE TERMS & CONDITIONS</v-btn>
      </v-toolbar-items>
      <v-menu class="hidden-md-and-up">
        <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
        <v-list>
          <v-list-tile class="v-list--three-line">
            <v-list-tile-content>
              <v-list-tile-title><a href="tel:888-440-0599">888-440-0599</a></v-list-tile-title>
              <v-list-tile-title><a @click.stop="dialog = true">ORDER NOW</a></v-list-tile-title>
              <v-list-tile-title><a @click.stop="terms = true">SAMPLE TERMS & CONDITIONS</a></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-content>
      <!--<v-dialog-->
              <!--v-model="dialog"-->
              <!--max-width="80%"-->
      <!--&gt;-->
        <warranty-form v-if="dialog" v-on:closeTheOrderForm="closeDialog">

        </warranty-form>
      <!--</v-dialog>-->
      <v-dialog
              v-model="terms"
              max-width="80%"
      >
        <terms></terms>
      </v-dialog>
      <home
              id="homeComponent"
              v-if="!dialog"
              v-on:openTheOrderForm="openDialog"
              v-on:openTheTermSheet="openTerms"

      ></home>

    </v-content>
    <v-footer
            color="#0c1f2a"
            height="256"
            pa-5>
      <v-layout
              justify-center
              row
              wrap
              pa-5
              class="blueicons"
      >
        © All rights reserved. {{year}} Master Home Services, LLC. Home Solutions Warranty is a trademark owned by Master Home Services, LLC.
        <br>

      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
import Home from './components/Home'
import WarrantyForm from "./components/WarrantyForm";
import Terms from "./components/Terms.vue";

export default {
  name: 'App',
  components: {
    Home,
    WarrantyForm,
    Terms
  },
  data () {
      return {
        dialog: false,
        terms: false,
        takingOrders: false
      }
  },
  computed: {
    year: function() {
      const date = new Date();
      return date.getFullYear();
    }
  },
  methods: {
    openDialog(event){
      console.log('OPEN DIALOG EMIT CALLED', event);
      // var container = this.$el.querySelector(".maxheight");
      // container.scrollTop = 0;
      window.scrollTo(0,0);
      this.dialog = true;

    },
    openTerms(event){
      this.terms = true;
    },
    closeDialog(event) {
      this.dialog = false;
    }
  }
}
</script>

<style>
  .darkblue {
    background: linear-gradient(to bottom, #1e536f, #3cafda);
    color: #ffffff;
    text-align: center;

  }

  .wsh-cta {
    background-color: #1d506c;
    color: #ffffff;
  }

  .lightblue {
    background-color: rgb(226, 243, 249);
  }
  .hero-image {
    background: linear-gradient(to bottom,rgba(255, 255, 255, 0.60) 70%,rgba(255, 255, 255, 1)), url("./assets/bg.jpg");
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }

  .blueicons {
    color: #65c0e2 !important;
  }

  .height700 {
    height: 700px;
  }

  .max100 {
    max-width: 100%;
  }

  .maxheight {
    max-height: 80%;
  }

  .wsh-center {
    text-align: center;
  }

  .uppercase {
    text-transform: uppercase;
  }
  .hsw-max-width {
    max-width: 80%;
  }

</style>
